export default __webpack_public_path__ + "static/media/home-architecture-slider-01.c21806fc.jpg";